import React from 'react'
import { observer, inject } from 'mobx-react'
import { NavItem } from 'react-bootstrap'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'

const etlRunnerNavbar = ({ store, runnerNavStatus, ...rest }) => {
  return store.runnerNavStatus &&
    <NavItem {...rest}
      className='hide-menu-title'
      onClick={() => store.goTo(linkConst.LINK_ETL_RUNNER)}>
      {store.runnerNavStatus === defaultConst.TITLE_FINISHED
        ? <i className='glyphicon glyphicon-ok' />
        : <i className='glyphicon glyphicon-refresh glyphicon-refresh-animate' />
      }
      <span>{store.__(store.runnerNavStatus)}</span>
    </NavItem>
}

export default inject('store')(observer(etlRunnerNavbar))
